import React, { useState } from 'react'
import { Icons, Table } from '@fabricks/ui-components'
import { useKeycloak } from 'react-keycloak'
import { get as _get } from 'lodash'
import { FbTableColumn, FbTablePagination, FbTableRow } from '@fabricks/ui-components/dist/components/Table/Table'
import { Skeleton } from '@material-ui/lab'
import { FilterParam, MaterialDto } from '../../api/models'
import { useMaterials } from "../../services/dataService";

interface MaterialTableProps {
    initLoadingTime?: number
    searchTerm?: string
    filter?: FilterParam[]
}

export const MaterialTable: React.FC<MaterialTableProps> = (props: MaterialTableProps) => {
    const { initLoadingTime, filter, searchTerm } = props
    const [initLoading, setInitLoading] = useState((initLoadingTime || 0) > 0)
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [sort, setSort] = useState({})
    const [keycloak] = useKeycloak()
    const { data, error, loading } = useMaterials(keycloak.token, {
        pagination: { page, size: pageSize },
        sort: Object.keys(sort)
            .map(key => {
                return _get(sort, key, null)
            })
            .filter(e => e != null && e.order !== undefined),
        q: searchTerm || null,
        filter: filter || []
    })

    const columns: FbTableColumn[] = [
        { id: 'name', label: 'Name' },
        { id: 'description', label: 'Description' },
        { id: 'customer_group', label: 'Picking group' },
        { id: 'storage_bin', label: 'Storage bin' },
        { id: 'mrp_type', label: 'MRP' },
        {
            id: 'package_type', label: 'Package type', renderValue: (val: string | null) => {
                if (!val) {
                    return (<div className="indicator_error" style={{ color: '#d32f2f', cursor: 'pointer', height: '16px' }}><Icons.Error /></div>)
                }
                return val
            }
        },
    ]
    const pagination: FbTablePagination = {
        rowsPerPage: _get(data, 'getMaterials.meta.size', pageSize),
        currentPage: _get(data, 'getMaterials.meta.offset', page),
        count: _get(data, 'getMaterials.meta.count', 0),
        onChangeRowsPerPage: event => setPageSize(parseInt(event.target.value, 10)),
        onChangePage: (event, newPage) => setPage(newPage),
    }
    const rows: FbTableRow[] = _get(data, 'getMaterials.data', []).map((material: MaterialDto) => {
        return {
            uuid: material.uuid,
            name: material.number,
            description: material.description,
            customer_group: material.customerGroup,
            storage_bin: material.storageBin,
            mrp_type: material.mrpType,
            package_type: _get(material, 'packageType.name', null)
        }
    })

    if (initLoading || loading) {
        setTimeout(() => setInitLoading(false), 2500)
        return (
            <>
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
            </>
        )
    }

    if (_get(data, 'getMaterials.error', null) != null) {
        return (
            <div>
                {_get(data, 'getMaterials.error.message', '')}
                {_get(data, 'getMaterials.error.code', '')}
            </div>
        )
    }

    if (error) {
        console.error(error)
        return <div>An unknown error has occured</div>
    }

    return (
        <Table
            columns={columns}
            pagination={pagination}
            rows={rows}
            onRowClick={(uuid: string) => console.log(`Clicked row with uuid ${uuid}`)}
        />
    )
}

export default MaterialTable
